export default "__VITE_ASSET__d645a4cb__"